/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Monitor(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Rect x={24} y={40.0002} width={208} height={160} rx={24} />
        <Path d="M160,216.0002H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
      </G>
    </Svg>
  );
}

export default Monitor;
